module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-page"
  }, [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t("label_articles")) + " [" + _vm._s(_vm.pagination.totalCount) + "]")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addArticle()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_add_article")) + "\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isMobile()) ? _c('div', {
    staticClass: "flex-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalCode),
      expression: "internalCode"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_internal_code'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.internalCode)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internalCode = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input section-bottom-xs",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalCode),
      expression: "internalCode"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_internal_code'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.internalCode)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internalCode = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.clickSearch()
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(_vm._s(_vm.locale.t("label_do_search")))])]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu scrollmenu-spaced"
  }, _vm._l((_vm.statuses), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedStatus = item;
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item.name))])])]), _vm._v(" \n            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('div', [_c('p', {
    staticClass: "toggle-btn-right",
    on: {
      "click": function($event) {
        _vm.showFilters = !_vm.showFilters
      }
    }
  }, [_vm._v("\n          " + _vm._s(!_vm.showFilters ? _vm.locale.t('label_show_filters') : _vm.locale.t('label_clear_filters')) + "\n          "), _c('i', {
    class: _vm.showFilters ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "toggle-btn-left",
    on: {
      "click": function($event) {
        _vm.showSort = !_vm.showSort
      }
    }
  }, [_vm._v(_vm._s(!_vm.showSort ? _vm.locale.t('label_show_sort') : _vm.locale.t('label_clear_sort')) + "\n          "), _c('i', {
    class: _vm.showSort ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "toggle-btn-left",
    on: {
      "click": function($event) {
        _vm.showInventory = !_vm.showInventory
      }
    }
  }, [_vm._v(_vm._s(!_vm.showInventory ? _vm.locale.t('label_show_inventory') : _vm.locale.t('label_hide_inventory')) + "\n          "), _c('i', {
    class: _vm.showInventory ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })])])]), _vm._v(" "), (_vm.showSort) ? _c('div', [_c('div', {
    staticClass: "scrollmenu scrollmenu-spaced"
  }, _vm._l((_vm.sorts), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.onSelectedSort(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClassSort(item)
    }, [_vm._v(_vm._s(_vm.isSelectedSort(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showFilters) ? _c('div', {
    staticClass: "filter-main"
  }, [_c('div', {
    staticClass: "section-top-xs article-filters-grid"
  }, [_c('div', {
    staticClass: "input-group article-filter-item article-filter-item--date"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t("label_from")) + ":")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm article-filter-input",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group article-filter-item article-filter-item--date"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t("label_to")) + ":")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm article-filter-input",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group section-top-xs article-filter-item article-filter-item--category"
  }, [_c('autocompleteObject', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleCategory),
      expression: "visibleCategory"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "viewId": "articlesCategoryFilter",
      "suggestions": _vm.categories,
      "placeholder": _vm.locale.t('label_a_category')
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newSelectedCategory = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.visibleCategory),
      expression: "!visibleCategory"
    }],
    staticClass: "input clickable",
    on: {
      "click": _vm.deleteCategory
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.newSelectedCategory) + " "), _c('i', {
    staticClass: "ti-trash"
  })])])], 1), _vm._v(" "), (!_vm.visibleCategory) ? _c('div', {
    staticClass: "section-top-xs"
  }, [_c('autocompleteObject', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleSubCategory),
      expression: "visibleSubCategory"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "viewId": "articlesSubCategoryFilter",
      "suggestions": _vm.selectedSubCategories,
      "placeholder": _vm.locale.t('label_a_sub_category')
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newSelectedSubCategory = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.visibleSubCategory),
      expression: "!visibleSubCategory"
    }],
    staticClass: "input clickable",
    on: {
      "click": _vm.deleteSubCategory
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.newSelectedSubCategory) + " "), _c('i', {
    staticClass: "ti-trash"
  })])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group section-top-xs article-filter-item"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_article_condition')) + ":")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleIsNewFilter),
      expression: "articleIsNewFilter"
    }],
    staticClass: "input date-input-sm article-filter-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.articleIsNewFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_all')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NEW"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_new_article')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "USED"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_used_article')))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group section-top-xs article-filter-item"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_kp_posted')) + ":")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kpPostedFilter),
      expression: "kpPostedFilter"
    }],
    staticClass: "input date-input-sm article-filter-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kpPostedFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("/")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "POSTED"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_posted_yes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NOT_POSTED"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_kp_posted_no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group section-top-xs article-filter-item"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_a_memory')) + ":")])]), _vm._v(" "), _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.addInfoMemorySuggestions,
      "placeholder": _vm.locale.t('label_filter_add_info_memory'),
      "changeEvery": true
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.addInfoMemoryFilter = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group section-top-xs article-filter-item"
  }, [_vm._m(0), _vm._v(" "), _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.ramMemorySuggestions,
      "placeholder": _vm.locale.t('label_filter_ram_memory'),
      "changeEvery": true
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.ramMemoryFilter = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group section-top-xs article-filter-item"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_a_color')) + ":")])]), _vm._v(" "), _c('autocompleteObject', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "suggestions": _vm.colorSuggestions,
      "placeholder": _vm.locale.t('label_a_color'),
      "changeEvery": true
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.colorFilter = $event
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showInventory) ? _c('div', {
    staticClass: "filter-main"
  }, [_c('div', {
    staticClass: "section-top article-filters-grid article-filters-grid--inventory"
  }, [_c('div', {
    staticClass: "input-group article-filter-item article-filter-item--date"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t("label_from")) + ":")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromInventoryDate),
      expression: "fromInventoryDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm article-filter-input",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromInventoryDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromInventoryDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group article-filter-item article-filter-item--date"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t("label_to")) + ":")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toInventoryDate),
      expression: "toInventoryDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm article-filter-input",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toInventoryDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toInventoryDate = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('h4', [_vm._v("\n      " + _vm._s(_vm.locale.t('label_amount_purchase_price')) + ":\n      " + _vm._s(parseFloat((_vm.totalPurchasePrice).toString()).toFixed(0)))]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), (!_vm.isMobile()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_internal_code')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_a_code') + '/' + _vm.locale.t('label_a_code_serial')) + "\n            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_category')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_sub_category')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_stock_number')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_color')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_memory')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_purchase_price')) + " €/RSD")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_desc')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_comment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_a_statuses')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_edit')))]), _vm._v(" "), (_vm.selectedStatus.id !== 7) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_delete')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedStatus.id === 7) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_recovery')) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(item, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_serial_num')
      }
    }, [_vm._v(_vm._s(String(item.id).padStart(6, '0')))]), _vm._v(" "), _c('td', {
      style: (_vm.getStyleName(item)),
      attrs: {
        "data-title": _vm.locale.t('label_a_name')
      }
    }, [(item.onService) ? _c('i', {
      staticClass: "ti-settings"
    }) : _vm._e(), _vm._v(" "), (_vm.shouldShowKpStatus(item)) ? _c('span', {
      staticClass: "article-kp-badge",
      class: _vm.getKpStatusClass(item)
    }, [_vm._v("\n                KP\n              ")]) : _vm._e(), _vm._v(" "), (_vm.shouldShowKpAdAge(item)) ? _c('span', {
      staticClass: "article-kp-age-badge"
    }, [_vm._v("\n                " + _vm._s(_vm.getKpAdAgeDays(item)) + "d\n              ")]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.fixEmptyNull(item.name)) + "\n              "), (item.isNewArticle === true) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v(" " + _vm._s(_vm.locale.t('label_new_article')) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      style: (_vm.getStyleName(item)),
      attrs: {
        "data-title": _vm.locale.t('label_a_code') + '/' + _vm.locale.t('label_a_code_serial')
      }
    }, [_vm._v(_vm._s(_vm.fixEmptyNull(item.code)) + "\n            ")]), _vm._v(" "), _c('td', {
      style: (_vm.getStyleName(item)),
      attrs: {
        "data-title": _vm.locale.t('label_a_category')
      }
    }, [_vm._v("\n              " + _vm._s(_vm.fixEmptyNull(item.mainCategory)) + "\n            ")]), _vm._v(" "), _c('td', {
      style: (_vm.getStyleName(item)),
      attrs: {
        "data-title": _vm.locale.t('label_a_sub_category')
      }
    }, [_vm._v("\n              " + _vm._s(_vm.fixEmptyNull(item.subCategory)) + "\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_stock_number')
      }
    }, [_vm._v("\n              " + _vm._s(item.stockNumber) + "\n              "), _vm._l((_vm.getApproveds(item)), function(approve) {
      return _c('i', {
        staticClass: "article-badge-approved"
      }, [_c('b', {
        staticClass: "badge-text"
      }, [_vm._v(" " + _vm._s(approve.substring(0, 1)))]), _vm._v(" "), _c('i', {
        staticClass: "ti-check"
      })])
    }), _vm._v(" "), _vm._l((_vm.getWaitingForApprove(item)), function(approve) {
      return _c('i', {
        staticClass: "article-badge-pending"
      }, [_c('b', {
        staticClass: "badge-text"
      }, [_vm._v(" " + _vm._s(approve.substring(0, 1)))]), _vm._v(" "), _c('i', {
        staticClass: "ti-alarm-clock"
      })])
    }), _vm._v(" "), (item.waitingApproval == null || item.waitingApproval.length === 0) ? _c('div', [(item.stockNumber === 0) ? _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.addToStock(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-plus"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_article_add_to_stock')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.stockNumber > 0) ? _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.removeFromStock(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-minus"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_article_remove_to_stock')) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.waitingApproval.includes(_vm.myUsername)) ? _c('div', {
      staticClass: "new-button-approve approve-btn-margin",
      on: {
        "click": function($event) {
          return _vm.approveArticle(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-check"
    }), _vm._v(_vm._s(_vm.locale.t('label_article_approve')) + "\n              ")]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_color')
      }
    }, [_vm._v(_vm._s(_vm.fixEmptyNull(item.color)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_memory')
      }
    }, [_vm._v(_vm._s((item.ramMemory != null ? _vm.fixEmptyNull(item.ramMemory) + '/' : '') + _vm.fixEmptyNull(item.addInfoMemory)) + "\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_purchase_price')
      }
    }, [_vm._v(_vm._s(item.purchasePrice) + " € / " + _vm._s(item.purchasePriceRsd) + " RSD\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_desc')
      }
    }, [_vm._v(_vm._s(_vm.fixEmptyNull(item.shortDescription)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_comment')
      }
    }, [_vm._v(_vm._s(_vm.fixEmptyNull(item.comment)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_a_statuses')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.showStatuses(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-link"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_a_statuses_show')) + "\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editArticle(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n              ")])]), _vm._v(" "), (_vm.selectedStatus.id !== 7) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteArticle(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.selectedStatus.id === 7) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_recovery')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.recoveryArticle(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-reload"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_recovery')) + "\n              ")])]) : _vm._e()])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', [_c('div', _vm._l((_vm.filteredUsers), function(item) {
    return _c('div', {
      staticClass: "payment-item"
    }, [_c('div', [_c('p', {
      staticClass: "payment-item-text"
    }, [(item.onService) ? _c('i', {
      staticClass: "ti-settings"
    }) : _vm._e(), _vm._v("["), _c('b', {
      staticClass: "article-id-color"
    }, [_vm._v(_vm._s(String(item.id).padStart(6, '0')))]), _vm._v("] " + _vm._s(_vm.fixEmptyNull(item.name)) + " -\n            "), (_vm.shouldShowKpStatus(item)) ? _c('span', {
      staticClass: "article-kp-badge",
      class: _vm.getKpStatusClass(item)
    }, [_vm._v("\n              KP\n            ")]) : _vm._e(), _vm._v(" "), (_vm.shouldShowKpAdAge(item)) ? _c('span', {
      staticClass: "article-kp-age-badge"
    }, [_vm._v("\n              " + _vm._s(_vm.getKpAdAgeDays(item)) + "d\n            ")]) : _vm._e(), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showMainCategory(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.fixEmptyNull(item.mainCategory)))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showSubCategory(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.fixEmptyNull(item.subCategory)))])]), _vm._v(" "), _c('p', {
      staticClass: "payment-item-text"
    }, [_c('i', {
      staticClass: "payment-item-text grey"
    }, [_vm._v(_vm._s(_vm.locale.t('label_last_inventory')))]), _vm._v(":\n            " + _vm._s(item.lastInventoryTimestamp != null ? _vm.formatDate(item.lastInventoryTimestamp) : '/') + "\n            "), _c('span', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.changeArticleInventory(item)
        }
      }
    }, [_c('b', [_c('i', {
      staticClass: "ti-arrow-up"
    }), _vm._v(_vm._s(_vm.locale.t('label_last_inventory_update')))])])]), _vm._v(" "), _c('p', {
      staticClass: "payment-item-text"
    }, [_c('i', {
      staticClass: "payment-item-text grey"
    }, [_vm._v(_vm._s(_vm.locale.t('label_a_code')))]), _vm._v(":\n            " + _vm._s(_vm.fixEmptyNull(item.code)) + "\n            "), (item.isNewArticle === true) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v(" " + _vm._s(_vm.locale.t('label_new_article')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('p', [_c('b', {
      staticClass: "payment-item-text",
      style: (_vm.getStyleName(item))
    }, [_vm._v(_vm._s(_vm.locale.t('label_a_stock_number')) + ":\n              " + _vm._s(item.stockNumber))]), _vm._v(" "), _vm._l((_vm.getApproveds(item)), function(approve) {
      return _c('i', {
        staticClass: "article-badge-approved"
      }, [_c('b', {
        staticClass: "badge-text"
      }, [_vm._v(" " + _vm._s(approve.substring(0, 1)))]), _vm._v(" "), _c('i', {
        staticClass: "ti-check"
      })])
    }), _vm._v(" "), _vm._l((_vm.getWaitingForApprove(item)), function(approve) {
      return _c('i', {
        staticClass: "article-badge-pending"
      }, [_c('b', {
        staticClass: "badge-text"
      }, [_vm._v(" " + _vm._s(approve.substring(0, 1)))]), _vm._v(" "), _c('i', {
        staticClass: "ti-alarm-clock"
      })])
    }), _vm._v(" "), (item.waitingApproval == null || item.waitingApproval.length === 0) ? _c('b', [(item.stockNumber === 0) ? _c('b', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.addToStock(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-plus"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_article_add_to_stock')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.stockNumber > 0) ? _c('b', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.removeFromStock(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-minus"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_article_remove_to_stock')) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.waitingApproval.includes(_vm.myUsername)) ? _c('b', {
      staticClass: "new-button-approve approve-btn-margin",
      on: {
        "click": function($event) {
          return _vm.approveArticle(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-check"
    }), _vm._v(_vm._s(_vm.locale.t('label_article_approve')) + "\n              ")]) : _vm._e()], 2)]), _vm._v(" "), _c('p', {
      staticClass: "payment-item-text"
    }, [_c('i', {
      staticClass: "payment-item-text grey"
    }, [_vm._v(_vm._s(_vm.locale.t('label_a_color')) + ":")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.fixEmptyNull(item.color)))])]), _vm._v(" "), _c('p', {
      staticClass: "payment-item-text"
    }, [_c('i', {
      staticClass: "payment-item-text grey"
    }, [_vm._v(_vm._s(_vm.locale.t('label_a_memory')) + ":")]), _vm._v(" "), _c('b', [_vm._v(_vm._s((item.ramMemory != null ? _vm.fixEmptyNull(item.ramMemory) + '/' : '') + _vm.fixEmptyNull(item.addInfoMemory)))])]), _vm._v(" "), _c('p', {
      staticClass: "payment-item-text"
    }, [_c('i', {
      staticClass: "payment-item-text grey"
    }, [_vm._v(_vm._s(_vm.locale.t('label_a_purchase_price')) + ":")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.purchasePrice) + " €")]), _vm._v(" / "), _c('b', [_vm._v(_vm._s(item.purchasePriceRsd) + " RSD")]), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('span', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.changeArticleProfit(item)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(item.profitEur == null ? '0' : item.profitEur) + " €")]), _vm._v(" /\n              "), _c('b', [_vm._v(_vm._s(item.profitRsd == null ? '0' : item.profitRsd) + " RSD")])]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "payment-item-text"
    }, [_c('i', {
      staticClass: "payment-item-text grey"
    }, [_vm._v(_vm._s(_vm.locale.t('label_a_comment')) + ":")]), _vm._v("\n            " + _vm._s(_vm.fixEmptyNull(item.comment)))]), _vm._v(" "), _c('p', {
      staticClass: "payment-item-text"
    }, [_c('i', {
      staticClass: "payment-item-text grey"
    }, [_vm._v(_vm._s(_vm.locale.t('label_a_desc')) + ":")]), _vm._v("\n            " + _vm._s(_vm.fixEmptyNull(item.shortDescription)))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container section-top-xs"
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.showStatuses(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-link"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_a_statuses_show')) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editArticle(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n            ")]), _vm._v(" "), (_vm.selectedStatus.id !== 7) ? _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteArticle(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedStatus.id === 7) ? _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.recoveryArticle(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-reload"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_recovery')) + "\n            ")]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('show-image-dialog', {
    attrs: {
      "show": _vm.showImagePreview,
      "image": _vm.imageToPreview,
      "userId": _vm.imageToPreviewUserId
    }
  }), _vm._v(" "), _c('sell-buy-article', {
    attrs: {
      "article": _vm.editArticleId,
      "quantity": _vm.editArticleQuantity,
      "show": _vm.editArticleId != null
    }
  }), _vm._v(" "), _c('change-profit-article', {
    attrs: {
      "articleObject": _vm.articleChangeProfit,
      "show": _vm.articleChangeProfit != null
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v("RAM:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6abf4e1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Article/Articles.vue
// module id = 781
// module chunks = 0